import React from 'react'
import PropTypes from 'prop-types'

import UserPreview from './UserPreview'

export default class DayView extends React.Component {

  static propTypes = {
    dateStr: PropTypes.string.isRequired,
    selectedWorkers: PropTypes.array.isRequired
  }

  render() {
    return (
      <div style={styles.container}>
        {
          this.props.selectedWorkers.map((user) => (
            <UserPreview
              key={user.userId}
              dateStr={this.props.dateStr}
              userInfo={user} />
          ))
        }
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflowY: 'auto',
    overflowX: 'hidden',
    width: '100%'
  }
}



// WEBPACK FOOTER //
// ./src/schedule/day/DayView.js